// src/services/brevo.js
// Appels aux Cloud Functions. Les destinataires et contenus des emails
// sont déterminés côté serveur : l'app n'envoie que des identifiants.
import { getFunctions, httpsCallable } from "firebase/functions";
import app from "./firebase";

const functions = getFunctions(app, "europe-west1");
const appeler = (nom) => httpsCallable(functions, nom);

// Email de bienvenue (envoyé une seule fois, à l'adresse du compte connecté)
export async function envoyerEmailInscription() {
  await appeler("envoyerEmailInscription")({});
}

// Mot de passe oublié : lien envoyé par le serveur (gabarit TomboLive)
export async function envoyerLienMotDePasse(email) {
  await appeler("envoyerLienMotDePasse")({ email });
}

// Crée les invitations et envoie les emails → { envoyees, echecs }
export async function creerInvitations({ orgId, tombolaId, emails, role }) {
  const res = await appeler("creerInvitations")({ orgId, tombolaId, emails, role });
  return res.data;
}

// Accepte une invitation (crée l'appartenance côté serveur) → { ok, role }
export async function accepterInvitation({ orgId, tombolaId, invitId, pseudo }) {
  const res = await appeler("accepterInvitation")({ orgId, tombolaId, invitId, pseudo });
  return res.data;
}

// Alerte 80 billets : le serveur compte lui-même et prévient l'admin si besoin
export async function verifierQuota80({ orgId, tombolaId }) {
  await appeler("verifierQuota80")({ orgId, tombolaId });
}

// Page publique de confirmation (QR code acheteur)
export async function getConfirmation({ venteId, orgId, tombolaId }) {
  const res = await appeler("getConfirmation")({ venteId, orgId, tombolaId });
  return res.data;
}

// Tirage au sort côté serveur → { tirageId, empreinte, resultats }
export async function lancerTirageServeur({ orgId, tombolaId }) {
  const res = await appeler("lancerTirage")({ orgId, tombolaId });
  return res.data;
}
